export const SLUGS = {
  careerPage: 'career_page_slug'
};
